import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../supabaseClient.js';

export default function UnitDetails({ serialNumber, onBack }) {
  const [events, setEvents] = useState([]);

  // 🔥 FIX: wrap in useCallback
  const fetchEvents = useCallback(async () => {
    const { data, error } = await supabase
      .from('events')
      .select(
        `
        action,
        created_at,
        units!inner(serial_number),
        from_org:organizations!events_from_org_id_fkey(name),
        to_org:organizations!events_to_org_id_fkey(name)
      `,
      )
      .eq('units.serial_number', serialNumber)
      .order('created_at', { ascending: true });

    if (error) {
      console.error(error);
    } else {
      setEvents(data);
    }
  }, [serialNumber]); // 🔥 dependency here

  // 🔥 FIX: add fetchEvents to dependency
  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  return (
    <div>
      <button onClick={onBack}>Back</button>

      <h2>Tracking: {serialNumber}</h2>

      {events.map((event, index) => (
        <div key={index}>
          <p>{event.action}</p>
          <p>
            {event.from_org?.name} → {event.to_org?.name}
          </p>
        </div>
      ))}
    </div>
  );
}
